/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// Decorators
import connection from '@src/connection';

// Icons
import MogamboIcon from '@src/components/Icon/mogambo.svg';
import Sidebar from '@haptik/helpers/build/esm/sidebar';

import * as maps from './maps';
import { MenuItems } from './routes';
import './VerticalMenu.scss';

@connection(maps.listenToStores, maps.getStateFromStores)
class VerticalMenu extends React.Component {
  constructor(props) {
    super(props);
    this._initLinks();
  }

  render() {
    const profileProps = {
      logout: maps.logout,
      permissions: this.props.permissions || [],
      username: this.props.username,
      useremail: this.props.useremail,
      authcode: this.props.authCode,
      toolname: 'Conversation Studio',
    };
    return (
      <Sidebar maxWidth={200} className="default-height">
        <Sidebar.Header>
          <Sidebar.Header.Icon
            tooltip="Conversation Studio"
            name={MogamboIcon}
          />
          <Sidebar.Header.Title>Conversation Studio</Sidebar.Header.Title>
        </Sidebar.Header>
        <Sidebar.Menu>
          {this.menuItems.map((item) => {
            return (
              <Sidebar.MenuItem
                {...item}
                key={item.tooltip}
                isActive={this._isActive(window.location.hash, item.paths)}
                onClick={() => this._navToTab(item.paths[0])}
              >
                {item.title}
              </Sidebar.MenuItem>
            );
          })}
        </Sidebar.Menu>
        <Sidebar.Footer>
          <Sidebar.Profile
            {...profileProps}
            key={profileProps.permissions.length}
          />
        </Sidebar.Footer>
      </Sidebar>
    );
  }

  _initLinks = () => {
    this.menuItems = MenuItems.reduce((acc, item) => {
      if (
        item.paths[0] === '/smart-skills' &&
        !this.props.canViewEditSmartSkill
      ) {
        return acc;
      }
      acc = [...acc, item];
      return acc;
    }, []);
  };

  _isActive(location, paths) {
    return paths.filter((path) => location.includes(path)).length > 0;
  }

  _navToTab(tab) {
    this.props.history.push(tab);
  }
}

VerticalMenu.propTypes = {
  canViewEditSmartSkill: PropTypes.bool,
  getPermissions: PropTypes.arrayOf(PropTypes.object),
  getUsername: PropTypes.string,
};

export default withRouter(VerticalMenu);
